import { render, staticRenderFns } from "./EmailSentIcon.vue?vue&type=template&id=50b90e14&scoped=true"
import script from "./EmailSentIcon.vue?vue&type=script&lang=js"
export * from "./EmailSentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b90e14",
  null
  
)

export default component.exports